<template>
    <div class="app-container">




    </div>
</template>

<script>



    export default {
        name: "News",

        data() {
            return {
                metaUrl: '/news',

            }
        },
        methods: {

        }
    }
</script>

<style scoped>

</style>
